import { Injectable } from '@angular/core';
import { IOperations, IRestrictedOperations, IRestrictedReasons } from '@interfaces/operations';
import { ToastController } from '@ionic/angular';
import { FirebaseService } from '@services/firebase/firebase.service';

@Injectable({
  providedIn: 'root',
})
export class UserRestrictionsService {

  private userRestrictions: IRestrictedReasons;
  private readonly RESTRICTED_USER_MESSAGE = 'No se pudo crear la orden porque tu ' +
    'cuenta está restringida, para resolver esto contáctate con Soporte';
  private readonly DEFAULT_RESTRICTED_OPERATIONS: IRestrictedOperations = {
    canBuyUSD: false,
    canSellUSD: false,
    canBuyStocks: false,
    canSellStocks: false,
    canBuyPortfolio: false,
    canSellPortfolio: false,
    canTransferFromPortfolioToPortfolio: false,
    canTransferStocks: false,
    canTransferFromStocksToPortfolio: false,
    canTransferFromPortfolioToStocks: false,
    canDeposit: false,
  };

  constructor(
    private firebaseService: FirebaseService,
    private toastController: ToastController,
  ) { }

  isRestrictedUser(restrictedReason: keyof IRestrictedReasons | undefined): boolean {
    return restrictedReason && restrictedReason !== 'noRestricted';
  }

  async getRestrictions(reason: keyof IRestrictedReasons): Promise<IRestrictedOperations> {
    if (!this.userRestrictions) {
      const configsCollection = this.firebaseService.getCollection('configs');
      this.userRestrictions = await this.firebaseService.getDocument('userRestrictions', configsCollection);
    }

    if (!this.userRestrictions[reason]) {
      return this.DEFAULT_RESTRICTED_OPERATIONS;
    }

    return this.userRestrictions[reason];
  }

  async canOperate(restrictedReason: keyof IRestrictedReasons, operation: IOperations) {
    if (!this.isRestrictedUser(restrictedReason)) { return true; }

    const userRestrictions = await this.getRestrictions(restrictedReason);
    const operationString = operation.charAt(0).toUpperCase() + operation.slice(1);

    return userRestrictions['can' + operationString as keyof IRestrictedOperations];
  }

  async showRestrictedUserToast() {
    const toast = await this.toastController.create({
      message: this.RESTRICTED_USER_MESSAGE,
      duration: 2000,
      keyboardClose: false,
      translucent: false,
      animated: true,
      position: 'top',
      color: 'light',
    });
    toast.present();
  }
}
